export default __webpack_public_path__ + "static/profile-35cb6d7650889e5fb92d018db37d51a4.png";